export default __webpack_public_path__ + "static/media/microfone.bef79d18.svg";